//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/DesignSimulation.js";
import "../no/Object.js";
import "../no/BasePart.js";
let d=[[],[[[],"CreateViewContourBuilder",{R_:{builder:"DesignSimulation.ViewContourBuilder"}},0,0],[[],"ShowContour",{},0,0],[[],"HideContour",{},0,0],[[],"CreateViewTabularResultBuilder",{R_:{builder:"DesignSimulation.ViewTabularResultBuilder"}},0,0],[[],"CreateViewXygraphBuilder",{R_:{builder:"DesignSimulation.ViewXygraphBuilder"}},0,0],[[],"IsContourShown",{R_:{isContourShown:''}},0,0],[["fileName"],"ExportAnimationToGif",{},1,0],[[],"IsAnimationPlaying",{R_:{isPlaying:''}},0,0],[[],"CreateAnimationController",{R_:{animationController:"DesignSimulation.AnimationController"}},0,0],[[],"CreateResultSettingsBuilder",{R_:{builder:"DesignSimulation.ResultSettingsBuilder"}},0,0],[["contourIndex","minValue","maxValue","unitTag"],"GetContourLimits",{},1,0]],[]];
SPLM.DesignSimulation.PostManager = class extends SPLM.Object{
    constructor (owner){
        if(owner !== undefined){
            if(owner._owner !== undefined){
                super(owner._owner);
                this._owner = owner._owner;
            }
            else{
                super(owner);
                this._owner = owner;
            }
            this._d['ObjectId'] = this._owner._d['ObjectId'];
        }
        else{
            super();
        }
        this._d['Class'] = "SPLM.DesignSimulation.PostManager";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;